import FieldConfig from "../../../proto/field-config"
import FieldEstimate from "../../../generic/estimate/estimate"
import FieldItemModelCalculatedEstimate_TableCell from "./render/table/table-cell"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type";

export default class FieldItemModelCalculatedEstimate extends FieldEstimate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Estimate"
        this.label                                  = "Estimate"

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldItemModelCalculatedEstimate_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelCalculatedEstimate_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc

                    return calculatedValues?.total.value || 0
                }
            ],
            directions  : [sort]
        }
    }
}
